<template>
  <div class="dispute-tender__modal">
    <Modal
      :active="true"
      :primary-button-disabled="disputeModalLoading"
      tertiary-button-label="Cancel"
      primary-button-label="Save"
      size="small"
      :close-on-click-outside="false"
      @onClose="onClose()"
      @onConfirm="onSubmitClick">
      <template #header>
        <p>Update Tender</p>
      </template>
      <template #content>
        <div class="dispute-tender__modal__body">
          <div v-if="isBulk" class="dispute-tender__modal__body__selected">
            <span class="dispute-tender__modal__body__selected__header">
              Selected disputes
            </span>
            <span class="dispute-tender__modal__body__selected__content">{{
              getOhpDisputeIds()
            }}</span>
          </div>
          <Form
            ref="updateTenderForm"
            :form-data="formData"
            :default-values="fieldValues"
            @onSubmitForm="onSubmit" />
        </div>
      </template>
    </Modal>
  </div>
</template>

<script>
import { updateTenderFormFields } from "@/config/disputeUpdateModalConstant.js";

export default {
  name: "DisputeTenderModal",
  props: {
    disputeModalLoading: {
      type: Boolean,
      default: false,
    },
    isBulk: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
      default() {
        return {};
      },
    },
    bulkData: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      formData: updateTenderFormFields(),
      fieldValues: {
        isTender: this.isBulk.length ? false : this.data.isTender,
      },
    };
  },
  methods: {
    onClose() {
      this.$emit("onModalClose");
    },
    onSubmitClick() {
      this.$refs.updateTenderForm.validate();
    },
    saveCommentsCallback(comments, successResponse) {
      const commentHTML = document.createElement("p");
      commentHTML.innerHTML = comments;
      const commentsText = commentHTML.textContent.trim();
      if (commentsText) {
        if (this.bulkData.length) {
          this.$emit("saveBulkComments", {
            ohpDisputeIds: successResponse,
            commentText: commentsText,
            commentHtml: comments,
          });
        } else {
          this.$emit(
            "saveComments",
            { commentText: commentsText, commentHtml: comments },
            { ohpDisputeId: this.data.ohpDisputeId }
          );
        }
      }
    },
    onSubmit(formState) {
      if (this.bulkData.length) {
        this.$emit(
          "updateBulkTenderForm",
          {
            data: this.bulkData.map((item) => ({
              ohpDisputeId: item.ohpDisputeId,
              isTender: formState.isTender,
            })),
          },
          (successResponse) =>
            this.saveCommentsCallback(formState.comments, successResponse)
        );
      } else {
        this.$emit(
          "updateTenderForm",
          {
            ohpDisputeId: this.data.ohpDisputeId,
            isTender: formState.isTender,
          },
          () => this.saveCommentsCallback(formState.comments)
        );
      }
    },
    getOhpDisputeIds() {
      return this.bulkData
        .map((item) => {
          return item.ohpDisputeId;
        })
        .join(", ");
    },
  },
};
</script>

<style lang="scss">
@import "@/styles/imports";

.dispute-tender__modal {
  .modal--small {
    height: 500px;
    width: 500px;
  }
  &__body {
    &__selected {
      &__header {
        display: block;
        font-family: "Maersk Text Bold";
      }
      &__content {
        display: block;
        margin-bottom: 1rem;
      }
    }
    &__grid {
      .vs__dropdown-toggle {
        width: 452px;
      }
      .vs__dropdown-menu {
        width: 452px;
      }
    }
    &__editor {
      margin: 1rem 0 0.5rem 0;
      &__justification {
        display: inline;
        margin-right: 0.5rem;
      }
    }
  }
}
</style>
